import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import axios from 'axios';

// Public Code of Conduct page — unauthenticated. Pulls the canonical
// rules from the server so the content stays in sync with the version
// logged at signup.
const CodeOfConductPage = () => {
  const [rules, setRules] = useState([]);
  const [version, setVersion] = useState('');
  const [error, setError] = useState('');

  useEffect(() => {
    axios.get('/api/coc')
      .then(res => {
        setVersion(res.data.version || '');
        setRules(Array.isArray(res.data.rules) ? res.data.rules : []);
      })
      .catch(e => setError(e.message || 'Failed to load'));
  }, []);

  return (
    <div className="auth-container">
      <div className="auth-form fade-in" style={{ maxWidth: 720 }}>
        <h2 style={{ textAlign: 'center', color: '#d4af37', marginBottom: 4 }}>Code of Conduct</h2>
        {version && (
          <p style={{ textAlign: 'center', color: '#8a8a9a', fontSize: 12, marginBottom: 16 }}>
            Version {version}
          </p>
        )}
        {error && <div className="error-message" style={{ marginBottom: 12 }}>{error}</div>}
        <p style={{ color: '#ccc', fontSize: 14, lineHeight: 1.5, marginBottom: 16 }}>
          Realms of Loria is a shared world. By creating an account you agree to these rules.
          Violations may result in warnings, chat bans, or account bans.
        </p>
        <ol style={{ color: '#ccc', fontSize: 14, lineHeight: 1.6, paddingLeft: 20 }}>
          {rules.map((r, i) => (
            <li key={i} style={{ marginBottom: 10 }}>
              <strong style={{ color: '#d4af37' }}>{r.heading}.</strong>{' '}
              <span>{r.body}</span>
            </li>
          ))}
        </ol>
        <div className="text-center mt-2">
          <p style={{ color: '#ccc', marginTop: 16, fontSize: 13 }}>
            <Link to="/register" style={{ color: '#839dbf' }}>Back to Register</Link>
            {' \u00b7 '}
            <Link to="/login" style={{ color: '#839dbf' }}>Login</Link>
          </p>
        </div>
      </div>
    </div>
  );
};

export default CodeOfConductPage;
